/* unplugin-vue-components disabled */import { render } from "./FilePpt.vue?vue&type=template&id=8977062c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__